<template>
  <div>
    <van-search
      placeholder="请输入搜索关键词"
      @click="gosearch"
    />

    <!-- <div class="class"></div> -->
    <class></class>
    <van-tabbar
      active-color="#950f0f"
      route
    >
      <van-tabbar-item
        to="/"
        info=""
      >
        <span style="font-size:0.32rem">首页</span>

        <img
          slot="icon"
          src="../assets/footbar/2-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/class"
        info=""
      >
        <span style="font-size:0.32rem">产品分类</span>
        <img
          slot="icon"
          src="../assets/footbar/33-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/manufactures"
        info=""
      >
        <span style="font-size:0.32rem">厂家直发</span>
        <img
          slot="icon"
          src="../assets/footbar/4-02.png"
          style="width:0.65rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/car"
        info=""
      >
        <span style="font-size:0.32rem">购物车</span>
        <img
          slot="icon"
          src="../assets/footbar/5-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/my"
        info=""
      >
        <span style="font-size:0.32rem">我的</span>
        <img
          slot="icon"
          src="../assets/footbar/1-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'

import { Search, Tab, Tabs, Icon, Tabbar, TabbarItem } from 'vant'
import Class from '../components/class/class'
// import Search from '../components/page/search'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
export default {
  methods: {
    gosearch () {
      this.$router.push('search')
    }
  },
  components: {
    Class,
  }
}
</script>
<style lang="less" scoped>
.class {
  width: 100%;
  height: 10%;
}
</style>
